export default __webpack_public_path__ + "static/media/login-title-mobile-cn.6d80bbca.webp";